<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="checkFormBeforeSubmit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<form class="d-flex p-2" *ngIf="myForm" [formGroup]="myForm">
	<div class="w-50 text-center">
		<mat-label>Nazwa: </mat-label>
		<mat-form-field class="w-75" appearance="outline">
			<input matInput formControlName="name" required />
			<mat-error *ngIf="myForm.controls.name.invalid">Nieprwidłowa nazwa</mat-error>
		</mat-form-field>
	</div>
	<div class="w-50 text-center">
		<mat-label>Zakres: </mat-label>
		<mat-form-field class="w-75" appearance="outline">
			<mat-date-range-input formGroupName="dateRange" [rangePicker]="picker">
				<input matStartDate formControlName="lower" placeholder="Od" />
				<input matEndDate formControlName="upper" placeholder="Do" />
			</mat-date-range-input>
			<mat-hint>DD.MM.YYYY – DD.MM.YYYY</mat-hint>
			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
			<mat-error *ngIf="myForm.get('dateRange').get('lower').hasError('matStartDateInvalid')"
				>Nieprawidłowa data początkowa</mat-error
			>
			<mat-error *ngIf="myForm.get('dateRange').get('upper').hasError('matEndDateInvalid')"
				>Nieprawidłowa data końcowa</mat-error
			>
		</mat-form-field>
	</div>
</form>
